module.exports = __webpack_public_path__ + "4db467e56b85cbf0677ef9c5aba003a3.pdf";